import { Button } from 'antd'
import styled, { keyframes } from 'styled-components'

const flashBirthDayLabel = (color: string) => keyframes`
  0% { background-color: ${color}; color: #fffeff; }
  50% { background-color: #10123d; color: #fffeff; }
  100% { background-color: ${color}; color: #fffeff; }
`

export const LeftSection = styled.div`
  // width: 30%;
  min-width: 280px;
  width: 30%;
  // width: 280px;
  min-height: 851px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
`

export const CardImage = styled.div<{ $src: string }>`
  align-self: stretch;
  min-width: 240px;
  min-height: 240px;
  height: 240px;
  max-width: 240px;
  display: flex;
  flex-direction: column;
  padding-top: 13px;
  padding-bottom: 13px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 12px;
  margin-right: 20px;
  background-image: url(${(props) => props.$src});
  background-size: cover;
  background-position: center;
  border-radius: 6px;
`

export const CardImageContent = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  margin-bottom: 154px;
`

export const KiroLogo = styled.img`
  width: 30px;
  height: 30px;
  object-fit: fill;
`

export const AgeBox = styled.div`
  width: 30px;
  height: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 6px;
  margin-left: auto;
`

export const Text = styled.span<{
  $bold?: boolean
  $size?: number
  $color?: string
  $marginRight?: number
  $marginBottom?: number
  $marginTop?: number
}>`
  color: ${(props) => props.$color || 'var(--color-text-primary)'};
  font-size: ${(props) => props.$size || 16}px;
  font-weight: ${(props) => (props.$bold ? '700' : 'normal')};
  margin-right: ${(props) => (props.$marginRight ? `${props.$marginRight}px` : '0')};
  margin-bottom: ${(props) => (props.$marginBottom ? `${props.$marginBottom}px` : '0')};
  margin-top: ${(props) => (props.$marginTop ? `${props.$marginTop}px` : '0')};
`

export const SourceIdentifier = styled.button<{ $noBorder?: boolean; $bg?: string; $spread?: boolean }>`
  width: 216px;
  height: 30px;
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  /* source on the left, first paid amount on the right */
  justify-content: ${(props) => (props.$spread ? 'space-between' : 'center')};
  padding: ${(props) => (props.$spread ? '0 12px' : '0')};
  background: ${(props) => props.$bg || 'var(--color-bg)'};
  border-radius: 6px;
  border: ${(props) => (props.$noBorder ? 'none' : `1px solid var(--color-border-primary)`)};
  text-align: left;
  box-shadow: ${(props) => (props.$noBorder ? 'none' : 'var(--shadow-box)')};
`

export const NameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-right: 132px;
  width: 100%;
  text-transform: capitalize;
  // white-space: pre-line;
`
export const LastNameText = styled.span`
  color: var(--color-text-primary);
  font-size: 20px;
  font-weight: 800;
  margin-top: -6px;
  margin-bottom: 12px;
  width: 100%;
  text-transform: capitalize;
  // white-space: pre-line;
`
export const MetricRow = styled.div`
  align-self: stretch;
  display: flex;
  align-items: flex-start;
  margin-bottom: 12px;
  margin-right: 20px;
  gap: 8px;
`

export const MetricButton = styled.div`
  width: 58px;
  min-width: 58px;
  max-height: 58px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 3px;
  padding-left: 13px;
  padding-right: 13px;
  gap: 2px;
  text-align: left;
`

export const MetricValue = styled.span`
  color: var(--color-text-primary);
  font-size: 30px;
  margin-bottom: 11px;
`

export const ScanBox = styled.div`
  max-height: 58px;
  width: 108px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #ffce00;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 17px;
  padding-bottom: 17px;
  padding-left: 11px;
  padding-right: 11px;
`

export const DateBox = styled(Button)`
  height: 29px;
  min-width: 240px;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: transparent;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 2.5px;
  padding-bottom: 4px;
  padding-left: 12px;
  padding-right: 12px;
  margin-bottom: 118px;
  margin-right: 20px;
`

export const AppointmentCard = styled.div<{ $marginBottom?: string }>`
  align-self: stretch;
  min-width: 240px;
  height: 48px;
  display: flex;
  align-items: center;
  background: var(--color-bg);
  border-radius: 6px;
  margin-bottom: ${(props) => props.$marginBottom || '8px'};
  margin-right: 20px;
  gap: 9px;
  box-shadow: var(--shadow-box);
`

export const PersonImage = styled.img`
  width: 48px;
  height: 48px;
  object-fit: fill;
`

export const StartButton = styled.button`
  height: 52px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
  // margin-top: auto;
`

export const NextButton = styled.button`
  height: 52px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-primary);
  border-radius: 6px;
  border: 1px solid var(--color-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
  margin-top: auto;
`

export const UndoButton = styled.button`
  height: 52px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--color-bg);
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-bottom: 8px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
`

export const DoneButton = styled.button`
  height: 52px;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 6px;
  border: 1px solid var(--color-border-primary);
  padding-top: 13px;
  padding-bottom: 13px;
  margin-right: 20px;
  box-shadow: var(--shadow-box);
  text-align: left;
  margin-bottom: 8px;
`

export const AppointmentsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-height: 168px;
  min-height: 168px;
  overflow: hidden;
  margin-right: 20px;
  padding-right: 20px;
  justify-content: flex-end;
  margin-top: auto;
`
